// src/modules/app-views/leads/modals/showDistributeLeadsModal.jsx
// *******************************************************************************
// IMPERATIVE SHOW FUNCTION FOR DISTRIBUTE LEADS MODAL
// *******************************************************************************
// Usage: showDistributeLeadsModal({ leads: [leadObj], onSuccess: () => {} })
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import useZustand from 'hooks/useZustand';
import { darkTheme, lightTheme } from 'configs/appEngine';
import DistributeLeadsModal from '../pages/Init/modals/DistributeLeadsModal';

// *******************************************************************************
// THEME WRAPPER COMPONENT
// *******************************************************************************
const ThemeWrapper = ({ children }) => {
  const theme = useZustand('theme', 'currentTheme');
  const config = theme === 'dark' ? darkTheme : lightTheme;
  return <ConfigProvider theme={config}>{children}</ConfigProvider>;
};

// *******************************************************************************
// IMPERATIVE SHOW FUNCTION (default export)
// *******************************************************************************
function showDistributeLeadsModal({ leads = [], onSuccess } = {}) {
  const container = document.createElement('div');
  container.id = 'distribute-leads-modal-container';
  document.body.appendChild(container);

  const root = createRoot(container);

  let isModalOpen = true;

  const renderModal = () => {
    root.render(
      <ThemeWrapper>
        <DistributeLeadsModal
          show={isModalOpen}
          setShow={handleClose}
          leads={leads}
          afterClose={handleAfterClose}
          onSuccess={onSuccess}
        />
      </ThemeWrapper>
    );
  };

  const handleClose = () => {
    isModalOpen = false;
    renderModal();
  };

  const handleAfterClose = () => {
    setTimeout(() => {
      root.unmount();
      if (document.body.contains(container)) {
        document.body.removeChild(container);
      }
    }, 0);
  };

  renderModal();
}

export default showDistributeLeadsModal;
